module.exports = __webpack_public_path__ + "static/media/Empoleon_gaussian2.853953bd.png";